angular.module('iqxCore')
.controller('ResetPasswordCtrl', function ($scope, FormSvc, $sce) {
   FormSvc.setOptions($scope,{
      fetchAPI:{}, // No data fetch - initialise with empty record
      autoEdit:true, // Switch form straight to edit mode
      notLoggedIn:true
      })

  $scope.infoSent = $sce.trustAsHtml($scope.params.lang.pages.resetpassword.infosent)
  
  $scope.save=function () {
    $scope.setSubmitted(true) // Ensure all validation errors appear
    if ($scope.theForm.$invalid) {return}
    $scope.exec('call_/netforgottenpassword',$scope.theRecord)
    .then(function(res) {
      if (res != undefined) {
        $scope.wasSent=true
      }      
    })
  }
  $scope.wasSent=false
  $scope.fetch()  // Complete the initialise
    
})